module.exports = __webpack_public_path__ + "img/6.f0e3080a.webp";